import React from "react";
import { buildURL } from "@comparaonline/cloudinary-image";
import { StyleRules, withStyles, WithStyles } from "@material-ui/core/styles";

const skeletonSrc = buildURL("v1570822224/assets/placeholders/form-delightful/form-summary.svg");

const styles: StyleRules = {
  image: {
    backgroundImage: `url(${skeletonSrc})`,
    height: "25px",
    maxWidth: "100%",
    width: "250px"
  }
};

const BaseTotalResults: React.FC<WithStyles<typeof styles>> = ({ classes }) => (
  <div className={classes.image} role="img" />
);

export const Placeholder = withStyles(styles)(BaseTotalResults);
